<template>
  <div class="prize-box" v-if="!hasFinished || onEdit">
    <div class="prize-info">
      <ul>
        <li>
          <label class="sectit">论文题目：</label>
          <div class="secon p-in">
            <el-input v-model="papername" placeholder="发表论文题目" @focus="nameFocus"></el-input>
            <span class="err" v-if="nameErr">请填写论文题目</span>
          </div>
        </li>
        <li>
          <div class="span2">
            <label class="sectit">发表日期：</label>
            <div class="secon">
              <el-date-picker v-model="publishDate" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" @change="dateSelect"></el-date-picker>
              <span class="err" v-if="dateErr">请选择发表日期</span>
            </div>
          </div>
          <div class="span2">
            <label class="sectit">发表刊物：</label>
            <div class="secon">
              <el-input class="unit-in" v-model="journal" placeholder="刊物名称与刊号" @focus="journalFocus"></el-input>
              <span class="err" v-if="journalErr">请填写发表刊物</span>
            </div>
          </div>
        </li>
        <li style="padding-bottom: 10px;">
          <div class="title">刊物封面及目录和内容页照片：<span class="pic-err" v-if="imgErr">请上传刊物封面及目录和内容页照片</span></div>
        </li>
        <li class="pic-upload">
          <div class="pic-box" v-for="(imgurl, index) in imageUrlsList" :key="index">
            <img :src="imgurl" alt="">
            <div class="delete" :class="imgShow ? 'delete-img' : ''" @click="deleteImg(index)"></div>
          </div>
          <div class="unpic-box" v-if="imageUrlsList.length < 9">
            <input type="file" class="unpic-input" ref="filPaper" @change="getFile">
          </div>
        </li>
      </ul>
    </div>
    <div class="toggleInfo">
      <span @click="toggleLine(myIndex, 'add')" v-if="myIndex === 0">添加一行</span>
      <span @click="toggleLine(myIndex, 'delete')" v-else>删除本行</span>
    </div>
  </div>
  <div class="prize-box" v-else>
    <div class="prize-info">
      <ul>
        <li>
          <label class="sectit">论文题目：</label>
          <div class="secon p-in">{{papername}}</div>
        </li>
        <li>
          <label class="sectit">发表日期：</label>
          <div class="secon">{{publishDate}}</div>
        </li>
        <li>
          <label class="sectit">发表刊物：</label>
          <div class="secon">{{journal}}</div>
        </li>
        <li style="padding-bottom: 10px;">
          <div class="title">刊物封面及目录和内容页照片：</div>
        </li>
        <li class="pic-upload">
          <div class="pic-box" v-for="(imgurl, index) in imageUrlsList" :key="index">
            <img :src="imgurl" alt="">
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import api from '../../utils/api'
import config from '../../config'
export default {
  props: ['paperDetail', 'myIndex', 'aliClient', 'hasFinished', 'onEdit'],
  data () {
    return {
      papername: '',
      nameErr: false,
      publishDate: '',
      dateErr: false,
      journal: '',
      journalErr: false,
      imageUrls: [],
      imageUrlsName: [],
      imageUrlsList: [],
      imgErr: false,
      imgShow: false
    }
  },
  mounted () {
    if (this.paperDetail) {
      this.papername = this.paperDetail.paperTitle
      this.publishDate = this.paperDetail.publishDate
      this.journal = this.paperDetail.magazine
      this.imageUrlsList = this.paperDetail.imageUrls
      for (let i = 0; i < this.imageUrlsList.length; i++) {
        this.imageUrlsName.push(this.setUrlpath(this.imageUrlsList[i]))
      }
      // console.log(this.imageUrlsName)
      if (this.onEdit) {
        this.imgShow = true
      }
    } else {
      // console.log('初始化')
    }
  },
  methods: {
    toggleLine (index, type) {
      if (type === 'add') {
        this.$parent.addPaper()
      } else {
        this.$emit('deletePaper', index)
      }
    },
    nameFocus () {
      this.nameErr = false
    },
    dateSelect () {
      this.dateErr = false
    },
    journalFocus () {
      this.journalErr = false
    },
    paperSubmit () {
      // 全部填写或全部不填写
      if (this.papername !== '' || this.publishDate !== '' || this.journal !== '' || this.imageUrlsName.length > 0) {
        if (this.papername === '') {
          this.nameErr = true
          return false
        }
        if (this.publishDate === '') {
          this.dateErr = true
          return false
        }
        if (this.journal === '') {
          this.journalErr = true
          return false
        }
        if (this.imageUrlsName.length <= 0) {
          this.imgErr = true
          return false
        }
        let paperObj = {
          paperTitle: this.papername,
          publishDate: this.publishDate,
          magazine: this.journal,
          imageUrls: this.imageUrlsName
        }
        let paperNameObj = {
          paperTitle: this.papername,
          publishDate: this.publishDate,
          magazine: this.journal,
          imageUrls: this.imageUrlsList
        }
        this.$emit('paperResult', [paperObj, paperNameObj])
        return true
      } else {
        this.nameErr = false
        this.levelErr = false
        this.gradeErr = false
        this.unitErr = false
        this.dateErr = false
        this.imgErr = false
        this.$emit('paperResult', 0)
        return true
      }
    },
    // 上传图片
    getFile () {
      let _this = this
      let inputFile = _this.$refs.filPaper.files[0]
      let userId = window.sessionStorage.getItem('userId') ? window.sessionStorage.getItem('userId') : api.globalHeader.usrId
      let storeAs = 'szteacher-img/' + userId + '/' + _this.getObjKey(inputFile)
      if (inputFile) {
        if (inputFile.type !== 'image/jpeg' && inputFile.type !== 'image/png' && inputFile.type !== 'image/gif') {
          _this.$message({
            message: '不是有效的图片文件！',
            type: 'error'
          })
          return false
        }
        _this.aliClient.multipartUpload(storeAs, inputFile).then(function (result) {
          // console.log(result)
          if (result.res.status === 200) {
            _this.$message({
              message: '上传成功',
              type: 'success'
            })
            _this.imageUrlsList.push(config.imgCdnHost + result.name)
            _this.imageUrlsName.push(result.name)
            _this.imgShow = true
            _this.imgErr = false
          } else {
            _this.$message({
              message: '上传失败，请重试',
              type: 'error'
            })
          }
        }).catch(function (err) {
          _this.$message({
            message: '上传失败，请重试',
            type: 'error'
          })
        })
      } else {
        return false
      }
    },
    // 组装图片名称
    getObjKey (fileObj) {
      let objKey = this.getUuid() + '.' + fileObj.name.split('.')[fileObj.name.split('.').length - 1]
      return objKey
    },
    getUuid () {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        let r = Math.random() * 16 | 0
        let v = c === 'x' ? r : (r & 0x3 | 0x8)
        return v.toString(16)
      })
    },
    // 删除图片
    deleteImg (index) {
      this.imageUrlsList.splice(index, 1)
      this.imageUrlsName.splice(index, 1)
      if (this.imageUrlsList.length <= 0) {
        this.imgShow = false
      }
    },
    // 截取url字符串域名后面的部分
    setUrlpath (url) {
      let urlPath = new URL(url).pathname
      return urlPath.substr(urlPath.indexOf('/') + 1, urlPath.length - 1)
    }
  },
  watch: {
    onEdit (val) {
      if (this.imageUrlsList.length > 0) {
        this.imgShow = true
      } else {
        this.imgShow = false
      }
    }
  }
}
</script>
<style scoped>
.prize-box li {
    display: flex;
    align-items: center;
    padding-bottom: 20px;
  }

  .prize-box li .p-in {
    flex: 1;
  }

  .prize-box li .sectit {
    font-size: 14px;
    width: 70px;
    color: #333;
  }

  .prize-box li .secon {
    position: relative;
    font-size: 14px;
  }

  .prize-box li .secon .err {
    position: absolute;
    left: 0;
    top: 40px;
    color: #ff0000;
    font-size: 12px;
  }

  .prize-box li .pic-err {
    color: #ff0000;
    font-size: 12px;
  }

  .prize-box li .span2 {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .prize-box li .span2:first-child {
    margin-right: 25px;
  }

  .prize-box li .el-select {
    width: 185px;
  }

  .prize-box li .span2 .unit-in, .prize-box li .span2 .el-date-editor {
    width: 185px;
  }

  .prize-box li .title {
    width: 100%;
    font-size: 14px;
  }

  .toggleInfo {
    color: #008fe6;
    font-size: 12px;
    text-align: right;
  }

  .toggleInfo span {
    cursor: pointer;
  }

  .pic-upload {
    display: flex;
    flex-wrap: wrap;
    align-content: center;
    align-items: center;
    padding-left: 67px;
  }

  .unpic-box {
    position: relative;
    width: 120px;
    height: 120px;
    background: #fff url('../../assets/add_icon.png') center center no-repeat;
    background-size: 32px 32px;
    border: 1px dashed #ccc;
    border-radius: 5px;
    margin: 0 20px 10px 0;
  }

  .unpic-box .unpic-input {
    position: absolute;
    top: 0;
    left: 0;
    width: 120px;
    height: 120px;
    opacity: 0;
    z-index: 1;
  }

  .pic-box {
    position: relative;
    width: 120px;
    height: 120px;
    border: 1px dashed #ccc;
    border-radius: 5px;
    background: #fff;
    margin: 0 20px 10px 0;
  }

  .pic-box img {
    width: 120px;
    max-height: 120px;
  }
  .pic-box .delete-img {
    display: none;
    position: absolute;
    top: 0;
    left: 0;
    width: 120px;
    height: 120px;
    z-index: 1;
    border-radius: 5px;
    background: rgba(0, 0, 0, 0.5) url('../../assets/delete.png') center center no-repeat;
    background-size: 32px 32px;
    cursor: pointer;
  }

  .pic-box:hover .delete {
    display: block;
  }
</style>
